export default __webpack_public_path__ + "static/media/Group 3377.58e5ef92.png";